import { render } from "./CreateDomainView.vue?vue&type=template&id=4e54400d&scoped=true"
import script from "./CreateDomainView.vue?vue&type=script&lang=js"
export * from "./CreateDomainView.vue?vue&type=script&lang=js"

import "./CreateDomainView.vue?vue&type=style&index=0&id=4e54400d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e54400d"]])

export default __exports__